import { useTranslation } from "react-i18next"
import { CardBodyHeader, CardBodyHeaderTitle } from "@/components/ui/card"
import { Tag } from "@/components/ui/tag"
import { RequestType as Request } from "@/types/__generated__/union-types"

interface RequestTypeSelectProps {
  requestType: Request
}

export const RequestType = ({ requestType }: RequestTypeSelectProps) => {
  const { t } = useTranslation()

  return (
    <section data-testid="request-type-section" className="border-b">
      <CardBodyHeader data-testid="request-type-title" className="w-full items-center justify-between border-t-0 pr-4">
        <CardBodyHeaderTitle>{t("scheduling.waitingRoom.requestType.requestType")}</CardBodyHeaderTitle>
        <Tag label={t(`scheduling.waitingRoom.requestType.${requestType}`)} />
      </CardBodyHeader>
    </section>
  )
}
